import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import ZINDEX from '@zola/zola-ui/src/styles/emotion/zIndex';

import styled from '@emotion/styled';

export const MobileFilterButtonWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: ${SPACING.MD};
  z-index: ${ZINDEX.middle};
  text-align: center;
`;

export const FilterButton = styled(ButtonV3)`
  gap: ${SPACING.XS};
`;
